import { SectorEquipmentType } from '@models/enums';

export const SECTOR_TYPES: SectorEquipmentType[] = [
  SectorEquipmentType.Alpha,
  SectorEquipmentType.Beta,
  SectorEquipmentType.Gamma,
  SectorEquipmentType.Delta,
];
